import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Client Menu',
  basePath: '/menu-client',
  reorderable: true,
  columns: [
    { key: 'title', label: 'Title' },
    { key: 'link', label: 'Link' },
    { key: 'parent_title', label: 'Parent' },
    { key: 'icon', label: 'Icon' },
  ],
  fields: [
    { key: 'title', label: 'Title', type: 'text', required: true },
    { key: 'link', label: 'Link', type: 'text' },
    { key: 'parent_id', label: 'Parent', type: 'async-select',
      optionsUrl: '/menu-client/options', defaultValue: '0' },
    { key: 'icon', label: 'Icon', type: 'async-select',
      optionsUrl: '/menu-client-icons/options' },
  ],
});
